import * as R from "ramda";
import React, { Component } from "react";
import SimpleModal from "../../../modules/popup/SimpleModal";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleButton from "../../../modules/commons/SimpleButton";
import withFormGroup from "../../../modules/commons/withFormGroup";
import { ACTIVITY_TYPE } from "../../common/Constants";
import FlexView from "react-flexview";
import Api from "../../../Services/Api";
import { mapToObjectDDL } from "../../common/mapper";
import { Status } from "../../common/Constants";
import ToggleButton from "react-toggle-button";

class MasterPartModifying extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryOptions: [],
      satuanOptions: [],
      qrCodeOption: [
        { label: "YES", value: "YES" },
        { label: "NO", value: "NO" },
      ]
    };
  }

  async componentDidMount() {
    this.fetchCategoryOptions();
    this.fetchSatuanOptions();
  }

  fetchCategoryOptions = async () => {
    try {
      let response = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).getAllBizparByParam({
        paramFilters: { bizparCategory: "PART_TYPE" },
      });

      if (response.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          categoryOptions: response.data.data.map((item) =>
            mapToObjectDDL(item.value, item.key)
          ),
        }));
      }
    } catch (error) {
      console.log("errors:", error);
    }
  };

  fetchSatuanOptions = async () => {
    try {
      let response = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).getAllBizparByParam({
        paramFilters: { bizparCategory: "UNIT_TYPE" },
      });

      if (response.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          satuanOptions: response.data.data.map((item) =>
            mapToObjectDDL(item.value, item.key)
          ),
        }));
      }
    } catch (error) {
      console.log("errors:", error);
    }
  };

  handleStatus = (status) => {
    this.props.setValue("status", status);
  };

  // handleSubmit = () => {
  //   console.log(this.props.controls);
  //   if (this.props.validate()) {
  //     if (!this.props.controls.qrCode.value) {
  //     } else {
  //       this.props.onSubmit(this.props.controls);
  //     }
  //   }
  // };

  handleSubmit = () => {
    if (this.props.validate()) {
      this.props.onSubmit(this.props.controls);
    }
  };

  handleReset = () => {
    if (!R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)) {
      this.props.setValue("kodePart", "");
    }
    this.props.setValue("partName", "");
    this.props.setValue("partCategory", {});
    this.props.setValue("satuan", {});
    this.props.setValue("qrCode", null);
  };

  render() {
    return (
      <SimpleModal
        title="Form Master Part"
        visible={this.props.visible}
        onClickClose={this.props.onClickClose}
        content={
          <ModalContainer>
            <SimpleInput
              id="input_text_kode_part"
              name="kodePart"
              label="Kode Part"
              readOnly={R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)}
              mandatory
              errorMessage={this.props.errors.kodePart}
              value={this.props.controls.kodePart.value}
              onChange={({ target }) =>
                this.props.setValue(target.name, target.value)
              }
            />
            <SimpleInput
              id="input_text_part_name"
              name="partName"
              label="Nama Part"
              mandatory
              errorMessage={this.props.errors.partName}
              value={this.props.controls.partName.value}
              onChange={({ target }) =>
                this.props.setValue(target.name, target.value)
              }
            />
            <SimpleDDL
              id="select_options_part_category"
              box="search"
              name="partCategory"
              label="Kelompok Part"
              mandatory
              isClearable
              errorMessage={this.props.errors.partCategory}
              options={this.state.categoryOptions}
              value={this.props.controls.partCategory.value}
              onChange={(value, { name }) => this.props.setValue(name, value)}
            />
            <SimpleDDL
              id="select_options_qrcode"
              box="search"
              name="qrCode"
              label="QR Code"
              mandatory
              isClearable
              options={this.state.qrCodeOption}
              value={this.props.controls.qrCode?.value === null?null : this.state.qrCodeOption.find(
                (opt) => opt.value === this.props.controls.qrCode?.value
              )}
              errorMessage={this.props.errors.qrCode}
              onChange={(selectedOption, { name }) => {
                this.props.setValue(name, selectedOption?.value);
              }}
            />
            <FlexView
              style={{
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <SimpleDDL
                id="select_options_satuan"
                box="search"
                name="satuan"
                label="Satuan"
                mandatory
                isClearable
                errorMessage={this.props.errors.satuan}
                containerclassname="flex-1 margin-right-20px"
                options={this.state.satuanOptions}
                value={this.props.controls.satuan.value}
                onChange={(value, { name }) => this.props.setValue(name, value)}
              />
              <ToggleButton
                name="status"
                label="Status"
                value={R.equals(
                  this.props.controls.status.value,
                  Status.ACTIVE
                )}
                onToggle={(value) =>
                  this.handleStatus(!value ? Status.ACTIVE : Status.INACTIVE)
                }
              />
            </FlexView>
            <FlexView hAlignContent="right">
              {/* <SimpleButton
                                type="button"
                                secondary
                                onClick={() => this.props.onDelete()}
                            >
                                Hapus
                            </SimpleButton> */}
              <SimpleButton
                type="button"
                // secondary
                onClick={this.handleReset}
              >
                Hapus
              </SimpleButton>
              <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
            </FlexView>
          </ModalContainer>
        }
      />
    );
  }
}

export default withFormGroup(MasterPartModifying);